'use client';

import { useRouter } from 'next/navigation';
import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import FaIcon, { faTriangleExclamation } from '../../../../components/icon/FaIcon/FaIcon';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import styles from './OptionLinkCard.module.scss';

export type OptionLinkCardProps = {
  lotteryDrawHistoryId: number;
};

function OptionLinkCard({ lotteryDrawHistoryId }: OptionLinkCardProps) {
  const router = useRouter();
  const handleOptionInputClick = () => {
    router.push(`/account/collection/option?lotteryHistoryId=${lotteryDrawHistoryId}`);
  };

  return (
    <div className={styles.componentStyle}>
      <div className={`${utilsStyles.centeredVertical} `}>
        <div>
          <span className={`${utilsStyles.primaryColor} ${utilsStyles.textMedium}`}>
            <FaIcon icon={faTriangleExclamation} size='lg' />
          </span>
          <span className={`${utilsStyles.textBold} ${utilsStyles.textMedium} ${utilsStyles.primaryColor}`}>
            {/* アイコンとテキストの間に半角空白一文字の対応を入れたいため、半角空白を入れている */}
            &nbsp;オプション入力が必要な景品があります
          </span>
        </div>
        <p className={`${utilsStyles.textBold} ${utilsStyles.textMedium} ${utilsStyles.primaryColor}`}>
          入力期限を過ぎると自動入力されますのでご注意ください
        </p>
      </div>
      <div className={`${utilsStyles.mtSmall} ${layoutStyles.centeredBtnWrapper}`}>
        <ActionButton onClick={handleOptionInputClick} size='large' color='primary'>
          オプション入力をする
        </ActionButton>
      </div>
    </div>
  );
}

export default OptionLinkCard;
